import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
    AccountFilter,
    ClientTypeFilter,
    ConstructionTypeFilter,
    EnergyLabelFilter,
    FixedPeriodFilter,
    LoanFormFilter,
    NHGFilter,
    SubmitFilter,
} from './Filters';
import Content from './General/Content';
import Filters from './General/Filters';
import InterestMarketValueTable from './InterestTables/InterestMarketValueTable';

import { MARKET_VALUE_FILTERS } from '../../Constants/Interest/Filter';

import { disablePdfButton } from '../../Store/Pdf/action';

const InterestMarketValue: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(disablePdfButton());
    }, []);

    return (
        <div className="interest-content-wrapper" data-testid="interest-market-value">
            <Filters>
                <SubmitFilter filterProperties={MARKET_VALUE_FILTERS} />
                <hr />
                <LoanFormFilter />
                <hr />
                <FixedPeriodFilter />
                <hr />
                <EnergyLabelFilter />
                <hr />
                <AccountFilter />
                <hr />
                <ConstructionTypeFilter />
                <hr />
                <NHGFilter />
                <hr />
                <ClientTypeFilter />
            </Filters>
            <Content>
                <InterestMarketValueTable />
            </Content>
        </div>
    );
};

export default InterestMarketValue;
